import { MdAccessTime } from 'react-icons/md';

import s from './PendingBadge.module.scss';

export function PendingBadge() {
  return (
    <span className={s.badge}>
      Invited
      <span className={s.icon}>
        <MdAccessTime size={12} aria-hidden="true" />
      </span>
    </span>
  );
}
